import Link from 'next/link';
import { FaFacebook, FaInstagram } from 'react-icons/fa';
import { social } from '@/lib/data';

export default function Socials() {
  return (
    <div className="flex flex-row space-x-6 py-4 md:justify-start justify-center">
      <Link
        href={social.instagram}
        id="instagram-link"
        className="text-4xl text-cta-100 hover:text-cta-900 transition-colors duration-300"
        aria-label="Instagram">
        <FaInstagram />
      </Link>
      <Link
        href={social.facebook}
        id="facebook-link"
        className="text-4xl text-cta-100 hover:text-cta-900 transition-colors duration-300"
        aria-label="Facebook">
        <FaFacebook />
      </Link>
    </div>
  );
}
